<ng-container>
  <div class="body-cell title" [ngClass]="hostClass" [ngStyle]="hostStyle">
    <span class="text-[10px] text-c-d2">
      {{ isInternational ? houseCount : '余' + houseCount }}
    </span>
    <div class="right-icon-wrapper">
      <div
        *ngIf="showOversale"
        class="oversale"
        nz-popover
        nzTrigger="hover"
        [nzPopoverTitle]="''"
        [nzPopoverContent]="typeOversaleContent"
      ></div>

      <div
        *ngIf="inventoryDiffInfo"
        class="exclamation"
        nz-popover
        nzTrigger="hover"
        [nzPopoverTitle]="''"
        [nzPopoverContent]="exclamationPopTpl"
      ></div>
    </div>

    <ng-template #typeOversaleContent>
      <host-auto-popover
        type="oversale"
        (onClickEditOversale)="
          router.navigate(['/app/room_types/detail'], { queryParams: { id: house.house_type_id, subTab: 1 } })
        "
      ></host-auto-popover>
    </ng-template>

    <ng-template #exclamationPopTpl>
      <host-auto-popover type="inventory-diff" [inventoryDiffList]="inventoryDiffInfo"></host-auto-popover>
    </ng-template>
  </div>
</ng-container>
